import { useQuery } from '@tanstack/react-query';
import {
  getExercisesInstitutions,
} from '../queries/institutions';

type FetchExercisesInstitutionsParams = {
  areasFilter?: any[];
  courseId?: string;
  courseWeekId?: string;
  difficulty?: string[];
  hasVideoResolution?: boolean;
  hasntDone?: boolean;
  simulationType?: string;
  institutionType?: string[];
  year?: string[];
  enabled?: boolean;
};

function useFetchExercisesByInstitutions(params?: FetchExercisesInstitutionsParams) {
  const { data, isError, error, isSuccess, isPending, refetch } = useQuery({
    queryKey: [
      'fetch-exercises-institutions',
      params?.areasFilter ?? [],
      params?.courseId ?? '',
      params?.courseWeekId ?? '',
      params?.year ?? [],
      params?.difficulty ?? [],
      params?.hasVideoResolution ?? false,
      params?.hasntDone ?? false,
      params?.simulationType ?? '',
      params?.institutionType ?? [],
    ],
    queryFn: () => getExercisesInstitutions(params),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
    enabled: params?.enabled !== false,
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    refetch,
  };
}

export { useFetchExercisesByInstitutions };
